import { Status } from './models';

export class OrderStatus extends Status {
  // This is the name used as module name of the Vuex Store.
  static entity = 'order_statuses';

  static fields() {
    return {
      ...super.fields(),
    };
  }
}

export default OrderStatus;
